import { LoadingShaperProp } from '../properties';
import { LoadingShapeType } from '../types';

export function getLoadingShape(shape?: LoadingShapeType) {
  if (!shape) return '';

  return LoadingShaperProp[shape];
}
